import React from "react";
import { Col, Container, Row, Form } from "react-bootstrap";
import PropTypes from "prop-types";
import { useWorkOrderItems } from "../../data/WorkItemHook";
import { useWorkItemTemplates } from "../../data/WorkItemTemplatesHook";
import DomesticFieldReactiveWorkItemEdit from "./DomesticFieldReactiveWorkItemEdit";
import DomesticCMVWorkItemEdit from "./DomesticCMVWorkItemEdit";
import DisconnectionWorkItemEdit from "./DisconnectionWorkItemEdit";
import ReconnectionWorkItemEdit from "./ReconnectionWorkItemEdit";
import DomesticProjectWorkItemEdit from "./DomesticProjectWorkItemEdit";

function WorkItemEdit({ editing }) {
  const workItemsRepository = useWorkOrderItems();
  const workItemTemplatesRepository = useWorkItemTemplates();

  const workItemTemplates =
    workItemTemplatesRepository.getCurrentWorkItemTemplates();

  const handleUpdateWorkItemTemplate = (e) => {
    const newWorkItemTemplate = workItemTemplates.find(
      (template) => template.id === e.target.value
    );
    const current = workItemsRepository.getEntry();
    const revised = {
      ...current,
      workitemtemplateid: newWorkItemTemplate.id,
      workitemtemplateref: newWorkItemTemplate.ref,
    };
    workItemsRepository.setEntry(revised);
  };

  const components = {
    DomesticFieldReactive: DomesticFieldReactiveWorkItemEdit,
    DomesticCMV: DomesticCMVWorkItemEdit,
    Disconnection: DisconnectionWorkItemEdit,
    Reconnection: ReconnectionWorkItemEdit,
    "DomesticProject-PropertyAsset": DomesticProjectWorkItemEdit,
    "DomesticProject-PropertyInstallation": DomesticProjectWorkItemEdit,
    "DomesticProject-PropertyOptimiseException": DomesticProjectWorkItemEdit,
    "DomesticProject-PropertyMeterException": DomesticProjectWorkItemEdit,
  };

  const current = workItemsRepository.getEntry();
  const WorkItemForm = components[current.workitemtemplateref];

  return (
    <Container className="work-order-entry-work-item-entry-container">
      {!editing && (
        <Row>
          <Form.Group className="mb-3" controlId="workItemTemplate">
            <Form.Label>Work Item Template</Form.Label>
            <Form.Select
              value={current.workitemtemplateid}
              onChange={handleUpdateWorkItemTemplate}
              required
            >
              {workItemTemplates.map((template) => (
                <option key={template.id} value={template.id}>
                  {template.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Row>
      )}
      <Row>
        <Col>{WorkItemForm && <WorkItemForm editing={editing} />}</Col>
      </Row>
    </Container>
  );
}

WorkItemEdit.propTypes = {
  editing: PropTypes.bool,
};

WorkItemEdit.defaultProps = {
  editing: false,
};

export default WorkItemEdit;
